var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
/* global document */

import React from 'react';

var ClickListener = function (_React$Component) {
  _inherits(ClickListener, _React$Component);

  function ClickListener() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ClickListener);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ClickListener.__proto__ || Object.getPrototypeOf(ClickListener)).call.apply(_ref, [this].concat(args))), _this), _this.handleDocumentClick = function (evt) {
      if (!_this.element.contains(evt.target)) {
        _this.props.onClickOutside(evt);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ClickListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.handleDocumentClick);
    }
    /* istanbul ignore next */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleDocumentClick);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'div',
        {
          ref: function ref(el) {
            _this2.element = el;
          } },
        this.props.children
      );
    }
  }]);

  return ClickListener;
}(React.Component);

ClickListener.propTypes = {
  children: PropTypes.node.isRequired,
  onClickOutside: PropTypes.func.isRequired
};


export default ClickListener;


//////////////////
// WEBPACK FOOTER
// ./node_modules/carbon-components-react/es/internal/ClickListener.js
// module id = 69
// module chunks = 0